// 868md1kcd. The reports load the firm logo into memory. A very large image
// (for example 23167 x 16215) made the PowerPoint export fail, so uploads are
// limited to the size that the Manage Logo screen states. The backend checks it too.
export const MAX_LOGO_WIDTH = 2000;
export const MAX_LOGO_HEIGHT = 900;

export interface ImageSize {
  width: number;
  height: number;
}

export function exceedsLogoLimit(size: ImageSize | null): boolean {
  return !!size && (size.width > MAX_LOGO_WIDTH || size.height > MAX_LOGO_HEIGHT);
}

export function oversizedLogoMessage(size: ImageSize): string {
  return `Your logo is ${size.width} x ${size.height} pixels. Please upload a logo no larger than ${MAX_LOGO_WIDTH} x ${MAX_LOGO_HEIGHT} pixels.`;
}

// Resolves to null when the browser cannot read the file as an image.
export function readImageSize(file: Blob): Promise<ImageSize | null> {
  return new Promise(resolve => {
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
      URL.revokeObjectURL(url);
      resolve({width: img.naturalWidth, height: img.naturalHeight});
    };
    img.onerror = () => {
      URL.revokeObjectURL(url);
      resolve(null);
    };
    img.src = url;
  });
}
